module.exports = "<div class=\"alert\" *ngIf=\"message\"><i class=\"fa fa-exclamation-triangle\" aria-hidden=\"true\"></i> {{message.text}}</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/_directives/alert.component.html
// module id = ./src/app/_directives/alert.component.html
// module chunks = main